import { render, staticRenderFns } from "./SeamlessScroll.vue?vue&type=template&id=1b459a75&scoped=true"
import script from "./SeamlessScroll.vue?vue&type=script&lang=js"
export * from "./SeamlessScroll.vue?vue&type=script&lang=js"
import style0 from "./SeamlessScroll.vue?vue&type=style&index=0&id=1b459a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b459a75",
  null
  
)

export default component.exports